const KEY_P = 'permissions';
const KEY_E = 'entities';

export class HasPermission {

  public static check(entity: string, action: string): boolean {
    entity = entity.replace(/_/g, '').toUpperCase();

    const entities = (window.localStorage.getItem(KEY_E) || '').split(',');
    const actions = JSON.parse(window.localStorage.getItem(KEY_P) || '{}');

    if (entities.includes(entity)) {
      if (actions[entity] && actions[entity].includes(action.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
